/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_AgentsInputs */

const en_directory_footer_link_agents = /** @type {(inputs: Directory_Footer_Link_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For AI agents`)
};

const zh_directory_footer_link_agents = /** @type {(inputs: Directory_Footer_Link_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 智能体专用`)
};

/**
* | output |
* | --- |
* | "For AI agents" |
*
* @param {Directory_Footer_Link_AgentsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_agents = /** @type {((inputs?: Directory_Footer_Link_AgentsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_AgentsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_agents(inputs)
	return zh_directory_footer_link_agents(inputs)
});
export { directory_footer_link_agents as "directory.footer.link_agents" }